var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5716 14.4286V13C12.5716 12.2422 12.2706 11.5155 11.7348 10.9797C11.199 10.4439 10.4723 10.1428 9.7145 10.1428H4.00021C3.24245 10.1428 2.51572 10.4439 1.9799 10.9797C1.44409 11.5155 1.14307 12.2422 1.14307 13V14.4286M16.8574 14.4286V13C16.8569 12.3669 16.6462 11.752 16.2583 11.2516C15.8705 10.7513 15.3274 10.394 14.7145 10.2357M11.8574 1.66427C12.4719 1.82163 13.0167 2.17905 13.4057 2.6802C13.7947 3.18135 14.0058 3.79772 14.0058 4.43213C14.0058 5.06653 13.7947 5.6829 13.4057 6.18405C13.0167 6.6852 12.4719 7.04262 11.8574 7.19998M9.7145 4.42855C9.7145 6.00651 8.43531 7.2857 6.85735 7.2857C5.2794 7.2857 4.00021 6.00651 4.00021 4.42855C4.00021 2.8506 5.2794 1.57141 6.85735 1.57141C8.43531 1.57141 9.7145 2.8506 9.7145 4.42855Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/Employees.65cc7cbc4e67a94b9a13767cdae4d064.svg";
export { ForwardRef as ReactComponent };